<template>
  <div class="page-container">
    <div class="query-title">计划类型查询</div>

    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline class="form" size="mini">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="计划类型名称">
                    <el-input v-model="form.name" />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="计划类型编码">
                    <el-input v-model="form.value" />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="字典数据"
          :custome-config="() => vxeShowCustom('xTable')"
        >
          <template #button>
            <table-button name="add" tip="新增" @click="addDictRows" />
            <table-button name="export" tip="修改" @click="editDictRows" />
            <table-button name="export" tip="启用" @click="enableRow('INSERT')" />
            <table-button name="export" tip="禁用" @click="enableRow('DELETE')" />
            <table-button name="export" tip="导出" @click="exportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            max-height="500"
            align="center"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #status="{row}">
              <el-link
                size="mini"
                :type="row.status ? 'success' : 'danger'"
                effect="dark"
              >
                {{ row.status ? '启用':'禁用' }}
              </el-link>
            </template>
            <template #channel="{row}">
              {{ filterChannel(row) }}
            </template>
          </vxe-grid>

        </TableCommon>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <DictEdit v-if="dialogVisible" ref="DictEdit" :mode="mode" :edit-rows="editRows" />
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import DictEdit from './components/DictEdit.vue'
import { apiPlatformFindDictionaryByCode, apiFindPlanTypeToChannel, apiSavePlanTypeToChannel, apiFindPlanTypeLinkPriceType } from '@/api/common'
import { apiDropvalueMod } from '@/api/sap/common-sap'
import { frontExport } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
export default {
  components: { DictEdit },
  data() {
    return {
      mode: 'add',
      form: {
        name: '',
        value: ''
      },
      dialogVisible: false,
      gridOptions: {
        data: [],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 },
          { field: 'name', title: '计划类型名称' },
          { field: 'value', title: '计划类型编码' },
          { field: 'channelName', title: '渠道类型' },
          { field: 'priceTypeName', title: '价格类型' },
          { field: 'statusText', title: '状态', width: 100, slots: { default: 'status' }},
          { field: 'sequence', title: '排序号', width: 100 }
        ]
      },
      planTypeToChannelList: [],
      planTypeToPriceList: [],
      editRows: []
    }
  },
  computed: {
    ...mapGetters(['customerInfo']),
    dialogTitle() {
      return this.mode === 'add' ? '新增' : '编辑'
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.editRows = []
      }
    }
  },
  created() {
    this.init()
    this.fetchPlanTypePriceList()
  },
  methods: {
    async init() {
      const { data } = await apiFindPlanTypeToChannel()
      this.planTypeToChannelList = data
    },
    async fetchPlanTypePriceList() {
      const { data } = await apiFindPlanTypeLinkPriceType()
      this.planTypeToPriceList = data || []
    },
    async queryData() {
      const params = {
        code: 'A0002',
        ...this.form
      }
      const { data } = await apiPlatformFindDictionaryByCode(params)
      data.map(row => {
        const channel = this.planTypeToChannelList.find(item => row.value === item.salePlan)
        row.channel = channel?.channel || ''
        row.channelName = channel?.channelTextView || ''
        const price = this.planTypeToPriceList.find(item => item.planType === row.value)
        row.priceType = price?.priceType || ''
        row.priceTypeName = price?.priceTypeName || ''
        row.statusText = row.status === 1 ? '启用' : '禁用'
        row.toId = channel?.id
      })
      this.gridOptions.data = data
    },
    addDictRows() {
      this.dialogVisible = true
      this.mode = 'add'
    },
    async submitHandle() {
      const validData = this.$refs['DictEdit'].validRows()
      if (validData) {
        await this.requestApi(validData)
        this.dialogVisible = false
        await this.saveChannel(validData)
        await this.fetchPlanTypePriceList()
        this.queryData()
      }
    },
    async saveChannel(validData) {
      const data = validData.map(item => {
        return {
          id: item.toId || '',
          channel: item.channel,
          remark: '',
          salePlan: item.value
        }
      })
      await apiSavePlanTypeToChannel(data)
      await this.init()
    },
    async enableRow(mode) {
      const data = this.$refs['xTable'].getCheckboxRecords()
      if (!data.length) {
        return this.$message.warning('请选择有效的数据！')
      }
      if (mode === 'DELETE' && data.some(v => v.status === 0)) {
        return this.$message.warning('请选择已启用的数据！')
      } else if (mode === 'INSERT' && data.some(v => v.status === 1)) {
        return this.$message.warning('请选择已禁用的数据！')
      }
      await this.requestApi(data, mode)
      this.queryData()
    },
    async requestApi(pdata, mode) {
      const params = {
        user_bp: this.customerInfo.info.partner,
        mode: mode || (this.mode === 'edit' ? 'UPDATE' : 'INSERT'),
        type: 'A0002',
        data: pdata.map(item => {
          return {
            value_id: item.value,
            value_kt: item.name,
            status: mode === 'DELETE' ? 0 : item.status,
            sequence: item.sequence,
            pric_type: item.priceType || ''
          }
        })
      }
      const { message, msgtype } = await apiDropvalueMod(params)
      if (msgtype === 'S') {
        this.$message.success(message)
        this.queryData()
      } else {
        this.$message.error(message)
      }
    },
    editDictRows() {
      const data = this.$refs['xTable'].getCheckboxRecords()
      if (!data.length) {
        return this.$message.warning('请选择要修改的数据！')
      }

      if (data.some(v => v.status === 0)) {
        return this.$message.warning('请选择已启用的数据！')
      }
      this.editRows = data
      this.dialogVisible = true
      this.mode = 'edit'
    },
    reset() {
      this.form = {
        value: '',
        name: ''
      }
    },
    exportExcel() {
      frontExport(this.gridOptions.columns, this.gridOptions.data, '计划类型')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/planType.vue